module.exports = __webpack_public_path__ + "static/media/team3.37473c56.jpg";